/* Earth N Essence – product page behaviours (ene-pdp) */
(function () {
  if (window.__enePdpInit) return;
  window.__enePdpInit = true;
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Product video: use the product photo as the poster (the video's own first frame is often black)
    document.querySelectorAll('.ene-vwrap[data-poster]').forEach(function (w) {
      var v = w.querySelector('video');
      if (v) v.setAttribute('poster', w.getAttribute('data-poster'));
    });

    // Gallery thumbnails
    document.querySelectorAll('[data-ene-gallery]').forEach(function (g) {
      var thumbs = g.querySelectorAll('[data-ene-thumb]');
      var slides = g.querySelectorAll('[data-ene-slide]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-ene-thumb');
          thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-ene-slide') === id); });
        });
      });
    });

    // Quantity stepper + Buy Now
    document.querySelectorAll('[data-ene-form]').forEach(function (form) {
      var qty = form.querySelector('[data-ene-qty]');
      form.querySelectorAll('[data-ene-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-ene-step'), 10);
          qty.value = Math.max(1, v);
        });
      });
      var ret = form.querySelector('[data-ene-return]');
      var now = form.querySelector('[data-ene-now]');
      if (now && ret) {
        now.addEventListener('click', function () { ret.disabled = false; });
      }
      var sel = form.querySelector('[data-ene-variant]');
      if (sel) {
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          var p = document.querySelector('[data-ene-price]');
          if (p) p.textContent = o.getAttribute('data-price');
          var ok = o.getAttribute('data-available') === 'true';
          form.querySelectorAll('[data-ene-atc],[data-ene-now]').forEach(function (b) { b.disabled = !ok; });
        });
      }
    });

    function fmtMoney(fmt, cents) {
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }));
    }

    // Bundle options: switch the variant sent to the cart + displayed price
    document.querySelectorAll('[data-ene-form]').forEach(function (form) {
      var opts = form.querySelectorAll('[data-ene-opt]');
      if (!opts.length) return;
      var idInput = form.querySelector('[data-ene-id]');
      var price = form.querySelector('[data-ene-price]');
      var mrp = form.querySelector('[data-ene-mrp]');
      var save = form.querySelector('[data-ene-save]');
      var note = form.querySelector('[data-ene-note]');
      var baseNote = note ? note.textContent : '';
      opts.forEach(function (o) {
        o.addEventListener('change', function () {
          opts.forEach(function (x) { x.closest('.ene-opt').classList.toggle('is-on', x === o); });
          if (idInput) idInput.value = o.getAttribute('data-id');
          price.textContent = o.getAttribute('data-price');
          var m = o.getAttribute('data-mrp'), s = o.getAttribute('data-save');
          mrp.textContent = m || ''; mrp.hidden = !m;
          save.textContent = s || ''; save.hidden = !s;
          if (note) note.textContent = o.getAttribute('data-note') || baseNote;
          form.dispatchEvent(new CustomEvent('ene:price', { bubbles: true }));
        });
      });
    });

    // Cart progress bar (threshold unlock)
    document.querySelectorAll('[data-ene-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      var fmt = bar.getAttribute('data-money');
      var msg = bar.querySelector('[data-ene-bar-msg]');
      var fill = bar.querySelector('[data-ene-bar-fill]');
      var form = bar.closest('[data-ene-form]');
      var cartTotal = 0;
      function current() {
        var qty = form ? parseInt(form.querySelector('[data-ene-qty]').value, 10) || 1 : 1;
        var sel = form && form.querySelector('[data-ene-opt]:checked');
        var unit = sel ? parseInt(sel.getAttribute('data-raw'), 10) : 0;
        if (!sel) {
          var raw = form && form.querySelector('[data-ene-price]');
          unit = raw ? Math.round(parseFloat(raw.textContent.replace(/[^0-9.]/g, '')) * 100) || 0 : 0;
        }
        return cartTotal + unit * qty;
      }
      function render() {
        var total = current();
        var left = threshold - total;
        fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
        msg.textContent = left > 0
          ? bar.getAttribute('data-msg').replace('[amount]', fmtMoney(fmt, left))
          : bar.getAttribute('data-done');
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; render(); }).catch(render);
      if (form) {
        form.addEventListener('click', function () { setTimeout(render, 0); });
        form.addEventListener('ene:price', render);
        form.addEventListener('input', render);
      }
      render();
    });

    // Pincode check + estimated delivery date.
    // Pincode locations come from assets/ene-pincodes.json (GeoNames postal codes, CC BY 4.0; Mumbai refined with OpenStreetMap, ODbL).
    var eddData = null, eddLoading = null;
    function loadEdd(url) {
      if (eddData) return Promise.resolve(eddData);
      if (!eddLoading) eddLoading = fetch(url).then(function (r) { return r.json(); }).then(function (d) { eddData = d; return d; });
      return eddLoading;
    }
    function km(a, b) {
      var R = 6371, r = Math.PI / 180;
      var dLa = (b[0] - a[0]) * r, dLo = (b[1] - a[1]) * r;
      var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function pairs(str) {
      return (str || '').split(',').map(function (x) { var p = x.split(':'); return [parseFloat(p[0]), parseInt(p[1], 10)]; }).filter(function (x) { return !isNaN(x[0]) && !isNaN(x[1]); });
    }
    function lookup(d, pin) {
      if (d[pin]) return { pt: d[pin], approx: false };
      var tries = [pin.slice(0, 4), pin.slice(0, 3)];
      for (var t = 0; t < tries.length; t++) {
        var sx = 0, sy = 0, n = 0;
        for (var k in d) { if (k.indexOf(tries[t]) === 0) { sx += d[k][0]; sy += d[k][1]; n++; } }
        if (n) return { pt: [sx / n, sy / n], approx: true };
      }
      return null;
    }
    function istToday() {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var g = {}; parts.forEach(function (p) { g[p.type] = parseInt(p.value, 10); });
      return { date: new Date(Date.UTC(g.year, g.month - 1, g.day)), hour: g.hour };
    }
    function deliveryDate(days, cutoff, skipSun) {
      var now = istToday(), d = now.date;
      if (now.hour >= cutoff) d = new Date(d.getTime() + 864e5);
      if (skipSun && d.getUTCDay() === 0) d = new Date(d.getTime() + 864e5);
      var left = days;
      while (left > 0) {
        d = new Date(d.getTime() + 864e5);
        if (!(skipSun && d.getUTCDay() === 0)) left--;
      }
      return new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(d);
    }
    function estimate(box, d, pin) {
      var o = lookup(d, box.getAttribute('data-origin') || '400063');
      var t = lookup(d, pin);
      if (!o || !t) return null;
      var days, ward = o.pt[2] && t.pt[2] && o.pt[2] === t.pt[2];
      if (ward && !t.approx) {
        days = parseInt(box.getAttribute('data-local-days'), 10) || 2;
      } else {
        var dist = km(o.pt, t.pt), bands = pairs(box.getAttribute('data-bands'));
        days = bands.length ? bands[bands.length - 1][1] : 7;
        for (var i = 0; i < bands.length; i++) { if (dist <= bands[i][0]) { days = bands[i][1]; break; } }
        pairs(box.getAttribute('data-metros')).forEach(function (m) {
          if (pin.indexOf(String(m[0])) === 0 && m[1] < days) days = m[1];
        });
      }
      return { days: days, date: deliveryDate(days, parseFloat(box.getAttribute('data-cutoff')) || 14, box.getAttribute('data-skip-sunday') !== 'false') };
    }
    document.querySelectorAll('[data-ene-pin]').forEach(function (box) {
      var input = box.querySelector('[data-ene-pin-input]');
      var out = box.querySelector('[data-ene-pin-msg]');
      var free = (box.getAttribute('data-free') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var url = box.getAttribute('data-edd-url');
      function show(ok, html) { out.className = 'msg ' + (ok ? 'ok' : 'bad'); out.innerHTML = html; }
      function check() {
        var v = input.value.replace(/\D/g, '');
        if (v.length !== 6) { show(false, 'Please enter a valid 6-digit pincode.'); return; }
        try { localStorage.setItem('ene_pin', v); } catch (e) {}
        var isFree = free.some(function (p) { return v.indexOf(p) === 0; });
        var tail = isFree ? (box.getAttribute('data-free-msg') || '') : (box.getAttribute('data-other-msg') || '');
        if (!url) { show(true, tail); return; }
        show(true, 'Checking…');
        loadEdd(url).then(function (d) {
          var r = estimate(box, d, v);
          if (!r) { show(true, (tail ? tail + '<br>' : '') + 'We could not find that pincode. The delivery date is shown at checkout.'); return; }
          show(true, '<b>' + (box.getAttribute('data-edd-text') || 'Estimated delivery by [date]').replace('[date]', r.date) + '</b> <span class="d">· ' + r.days + '-day delivery</span>' + (tail ? '<br>' + tail : ''));
        }).catch(function () { show(true, tail); });
      }
      box.querySelector('[data-ene-pin-btn]').addEventListener('click', check);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      try {
        var saved = localStorage.getItem('ene_pin');
        if (saved && /^\d{6}$/.test(saved)) { input.value = saved; if (url) { /* wait until the page is idle, then estimate */ (window.requestIdleCallback || setTimeout)(check, 800); } }
      } catch (e) {}
    });

    // Sticky add-to-cart bar
    document.querySelectorAll('[data-ene-sticky]').forEach(function (bar) {
      var atc = document.querySelector('[data-ene-atc]');
      var priceSrc = document.querySelector('[data-ene-price]');
      var sp = bar.querySelector('[data-ene-sticky-price]');
      bar.querySelector('[data-ene-sticky-btn]').addEventListener('click', function () { if (atc) atc.click(); });
      if (!atc || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) {
        var e = es[0];
        bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        if (sp && priceSrc) sp.textContent = priceSrc.textContent;
      }).observe(atc);
    });

    // Copy discount code
    document.querySelectorAll('[data-ene-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-ene-copy');
        var done = function () { var old = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = old; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done); else done();
      });
    });

    // Frequently bought together
    document.querySelectorAll('[data-ene-fbt]').forEach(function (root) {
      var items = root.querySelectorAll('[data-ene-fbt-item]');
      var money = root.getAttribute('data-money');
      var totalEl = root.querySelector('[data-ene-fbt-total]');
      var countEl = root.querySelector('[data-ene-fbt-count]');
      var btn = root.querySelector('[data-ene-fbt-add]');
      function fmt(c) { return money.replace('{{amount}}', (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })); }
      function update() {
        var sum = 0, n = 0;
        items.forEach(function (i) {
          if (i.getAttribute('aria-pressed') === 'true') { sum += parseInt(i.getAttribute('data-price'), 10); n++; }
        });
        totalEl.textContent = fmt(sum);
        countEl.textContent = n;
        btn.disabled = n === 0;
      }
      items.forEach(function (i) {
        i.addEventListener('click', function () {
          i.setAttribute('aria-pressed', i.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          update();
        });
      });
      btn.addEventListener('click', function () {
        var list = [];
        items.forEach(function (i) {
          if (i.getAttribute('aria-pressed') === 'true') list.push({ id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 });
        });
        if (!list.length) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = 'Could not add – try again'; });
      });
      update();
    });
  });
})();
